import { useState } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import EarlyAccessForm from "@/components/EarlyAccessForm";

export default function EarlyAccessButton({
  label = "Request early access",
  compact = false,
  variant = "primary",
  "data-testid": testId = "cta-request-access",
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid={testId}
          data-cursor="hover"
          data-cursor-label="Join"
          className={
            variant === "ghost"
              ? "btn-ghost"
              : "btn-ink"
          }
          style={compact ? { padding: "12px 18px", fontSize: 11, letterSpacing: "0.2em" } : {}}
        >
          {label}
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid="early-access-modal"
        className="w-[92vw] max-w-2xl bg-ivory border border-ink p-0"
        style={{ borderRadius: 0 }}
      >
        <div className="p-8 md:p-10">
          <p className="eyebrow eyebrow-brass mb-4">The Founding List</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.02] mb-3">
            Be first to try <em className="italic">Underbloom.</em>
          </h2>
          <p className="text-pencil text-sm mb-8">
            Underbloom arrives in 2027. Join the list for first access and early pricing.
          </p>
          <EarlyAccessForm testidPrefix="modal" source="modal" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
